const FormGroupWrapper = ({title, hasTitle= true, isRequired= true, children, className=""}) => {
  return <div className={`mb-8 ${className}`}>
            {hasTitle &&
                <div className="font-medium mb-2">
                    {title} {isRequired ? "" : <i className="font-normal">(Optional)</i>}
                </div>}
            <div className="custom-card">
                {children}
            </div>
        </div>
}


export default FormGroupWrapper
